import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[libCreditCardExpiry]'
})
export class CreditCardExpiryDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput() {
    let input = this.el.nativeElement.value.replace(/\D/g, ''); // Remove non-numeric characters

    if (input.length > 4) {
      input = input.slice(0, 4); // Limit to MMYY format
    }

    // Auto-format MM/YY
    if (input.length >= 2) {
      const month = input.slice(0, 2);
      const year = input.slice(2);

      // Ensure month is valid (01-12)
      if (parseInt(month, 10) > 12) {
        input = `12${year}`;
      }

      input = year ? `${input.slice(0, 2)}/${input.slice(2)}` : input;
    }

    this.el.nativeElement.value = input;
  }
}
